export const storageListV2 = {
	layout: {
		title: "Estoques",
	},
	header: {
		searchPlaceHolder: "Pesquise pelo nome do estoque",
		createStorage: "Criar Estoque",
		storageTypeFilter: {
			local: "Local",
			central: "Central",
			all: "Todos os estoques (central e local)",
			ariaLabel: "Selecione o tipo de estoque",
		},
	},
	indicators: {
		storagesCount: {
			label: "Estoques cadastrados",
		},
		productsCount: {
			label: "Produtos em estoque",
		},
		totalCost: {
			label: "Custo em estoques",
		},
		zeroedProductsCount: {
			label: "Produtos qtd. zerada",
			seeProducts: "Ver produtos",
		},
		productsWithoutUnitCostValue: {
			label: "Produtos custo zerado",
			seeProducts: "Ver produtos",
		},
	},
	list: {
		productsCount_zero: "{{count}} produtos",
		productsCount_one: "{{count}} produto",
		productsCount_other: "{{count}} produtos",
		createdAt: "Criado em {{date}}",
		productsCount: "Em estoque",
		totalCost: "Custo total",
		attachedBars_zero: "{{count}} bares vinculados",
		attachedBars_one: "{{count}} bar vinculado",
		attachedBars_other: "{{count}} bares vinculados",
		seeBars: "Ver bares",
		noBarsLinked: "Nenhum bar vinculado",
	},
	attachedBarsDrawer: {
		drawerTitle: "Bares vinculados",
		title: "Bares",
		description: "Veja onde seu produto está disponível para consumo",
		linkedBarsLabel: "Bares vinculados",
		barDescription: {
			storage: "Estoque",
			printersIps: "IPs das impressoras",
		},
	},
	irregularProductsDrawer: {
		filters: {
			storage: "Estoque",
			selectStorage: "Selecione o estoque",
		},
		quantity: {
			title: "Produtos com quantidades zeradas",
			save: "Atualizar quantidades",
		},
		unitCostValue: {
			title: "Produtos com custos zerados",
			save: "Atualizar custos",
		},
		table: {
			columns: {
				product: "Produto",
				fiscalCode: "SKU",
				storage: "Estoque",
				quantity: "Quantidade",
				unitCostValue: "Custo unitário",
				totalCost: "Custo total",
			},
		},
		successUpdateIrregularProducts: "Produtos atualizados com sucesso",
	},
	actions: {
		editStorage: "Editar estoque",
		deleteStorage: "Excluir estoque",
	},
	persistStorageDrawer: {
		title: {
			create: "Criar estoque",
			edit: "Editar estoque",
		},
		form: {
			name: {
				label: "Nome do estoque",
				placeholder: "Nome do estoque",
				error: "Nome do estoque é obrigatório",
				maxLengthError: "O nome do estoque deve ter no máximo {{maxLength}} caracteres",
				nameInUse: "Nome já em uso",
			},
			type: {
				label: "Tipo de estoque",
				options: {
					local: "Local",
					central: "Central",
				},
			},
		},
		actions: {
			submitEdit: "Salvar Edições",
			submitCreate: "Criar Estoque",
		},
		successEditModal: "Estoque editado com sucesso",
		successCreateModal: "Estoque criado com sucesso",
	},
	modalDelete: {
		title: "Excluir Estoque",
		warningMessage: 'Tem certeza que deseja excluir o estoque "{{storageName}}"?',
		warningMessageStrong: "Essa ação não pode ser desfeita.",
		submit: "Excluir estoque",
		successDeleteModal: "Estoque excluído com sucesso",
	},
};

export type StorageListV2Translations = typeof storageListV2;
